import { useI18n } from '../i18n/I18nProvider'
import type { MessageKey } from '../i18n/messages'

/**
 * A fit band, in words.
 *
 * Bands are the only measure of fit the product ever shows — 决议 V1.2 §3.3: 精确分在任何层都不给,
 * 报告内同样不给精确分. An exact number would invite users to reverse-engineer the algorithm and
 * would freeze MATCH_V2 out of ever retuning it, because everyone would notice 88 became 86.
 *
 * An unknown band renders its own name rather than falling back to something friendlier: a band
 * the interface does not know about is a gap worth seeing.
 */
export function Band({ value }: { value: string | null | undefined }) {
  const { t } = useI18n()

  if (!value) {
    return null
  }

  const key = `band.${value}` as MessageKey
  const label = t(key)

  return <span className={`band band-${value.toLowerCase()}`}>{label === key ? value : label}</span>
}
